import {
  FaGithub,
  FaLinkedin,
  FaEnvelope,
} from "react-icons/fa";

export const links = [
  {
    index: 1,
    title: "Find me on LinkedIn",
    href: "https://www.linkedin.com/in/tzvikabruhis/",
    icon: <FaLinkedin />,
  },
  {
    index: 0,
    title: "Find me on Github",
    href: "https://github.com/64n35h4",
    icon: <FaGithub />,
  },
  {
    index: 2,
    title: "Contact me via email",
    href: "mailto:info@bruhis.net",
    icon: <FaEnvelope />,
  }
];
